import request from 'utils/request'

export const getBrazilDetail = id =>
  request().get(`bureau-report/query/dnb/brazil/lookup/${id}`)

export const getGlobalDetail = id =>
  request().get(`bureau-report/query/dnb/lookup/${id}`)

export const getGlobalReportDetail = id =>
  request().get(`bureau-report/query/dnb/report/${id}`)

export const getCrmDetail = id =>
  request().get(`bureau-report/query/dnb/crm/lookup/${id}`)

// ckr report
export const getCkrDetail = id =>
  request().get(`bureau-report/query/dnb/brazil/report/${id}`)

// crm report
export const getCrmFinancialReport = id =>
  request().get(`bureau-report/query/dnb/crm/financial/report/${id}`)
// 获取安华理达查询页
export const geAnwaridaDetail = id =>
  request().get(`bureau-report/query/anl/lookup/${id}`)
//财报更新申请
export const getFinicalSubmit = id =>
  request().get(`bureau-report/update/anl/lookup/${id}`)
export const getGoogolRepert = id =>
  request().get(`bureau-report/query/anl/bignum/${id}`)
export const geReportDeatail = id =>
  request().get(`bureau-report/query/anl/detail/${id}`)
export const download = id =>
  request().get(`bureau-report/export/anl/bignum/${id}`, {
    responseType: 'blob',
  })
export const detailDownload = id =>
  request().get(`bureau-report/export/anl/detail/${id}`, {
    responseType: 'blob',
  })
export const detailArchived = id =>
  request().get(`bureau-report/anl/convert/finance/detail/${id}`)
export const archived = id =>
  request().get(`bureau-report/anl/convert/finance/bignum/${id}`)
